/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Manager_Import_Row_CountInputs */



/**
* | output |
* | --- |
* | "{count} row(s)" |
*
* @param {Team_Manager_Import_Row_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_row_count = /** @type {((inputs: Team_Manager_Import_Row_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Row_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} ligne(s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Zeile(n)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} riga/e`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Строк: ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} fila(s)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.count} 行`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 行`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} पंक्ति(याँ)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} linha(s)`)
	return /** @type {LocalizedString} */ (`${i?.count} row(s)`)
});